<template>
  <div :class="buttonGroupClassNames">
    <KkButton
      v-if="footerOptions.clear"
      v-bind="clearButtonProps"
      @click="footerOptions.clear?.click?.()"
    />
    <KkButton
      v-if="footerOptions.cancel"
      v-bind="cancelButtonProps"
      @click="footerOptions.cancel?.click?.()"
    />
    <KkButton
      v-if="footerOptions.primary"
      v-bind="footerOptions.primary"
      @click="footerOptions.primary?.click?.()"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import KkButton from '../../KkButton';
import { dialogButtonGroupProps, FOOT_DIRECTION } from './dialog';

const props = defineProps(dialogButtonGroupProps);

const clearButtonProps = computed(() => ({
  type: 'text-secondary',
  hasTextUnderline: true,
  ...props.footerOptions.clear,
}));

const cancelButtonProps = computed(() => ({
  type: 'text-secondary',
  hasTextUnderline: true,
  ...props.footerOptions.cancel,
}));

const buttonGroupClassNames = computed(() => {
  const isHorizontal = props.footerDirection === FOOT_DIRECTION.HORIZONTAL;

  return [
    'kk-dialog-button',
    `kk-dialog-button--${props.footerDirection}`,
    isHorizontal && `kk-dialog-button--${props.footerAlign}`,
  ];
});
</script>
